import React, { useState, useEffect } from 'react';
import { Quill } from '@c';
import { Input, AudioPlayer } from '../../components';
import { InfoBlock } from '../../InfoBlock';

import styles from './style.module.scss';
import { Button } from '@mui/material';
import { regenerateScheme } from '@a/teacher';
import { teacherActions } from '@r/teacher/teacherSlice';
import { useSelector } from 'react-redux';
import { useActions } from '@h/useActions';
import SelectInput from '@mui/material/Select/SelectInput';

 
const ReasonModal = ({ isOpen, onClose, onSubmit, h3 , genitem }) => {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(inputValue);
    setInputValue('');
    onClose();
  };

  const handleCancel = () => {
    setInputValue('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <form onSubmit={handleSubmit}>
          <h3>{h3} {genitem}</h3>
          <input
            type="textarea"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Предложения..."
            autoFocus
          />
          <div className="modal-buttons">
            <button className={styles.button}  type="button" onClick={handleCancel}>
              Отмена
            </button>
            <button className={styles.button}  type="submit">Генерация {genitem}</button>
          </div>
        </form>
      </div>
    </div>
  );
};


//THEFORM

const Form = ({ data = {}, subject = null, onChange = () => {}, uniq = '' }) => {
    const [_data, setData] = useState(data);    
    const { regenerateSchemeStart } = useActions(teacherActions);
    const { isLoading, scheme, schemeId, update,  courseName } = useSelector(
        ({ teacher }) => teacher
    );



  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  

  const [isIModalOpen, setIsIModalOpen] = useState(false);
  const handleOpenIModal = () => setIsIModalOpen(true);
  const handleCloseIModal = () => setIsIModalOpen(false);
  


  const handleSubmit = (text) => {   
        handleGenerate(null, text) 
  };
  const handleISubmit = (text) => {   
        handleGenerate("image", text) 
  };



    useEffect(() => {
        onChange(_data);
    }, [_data]);
    
    const [updated, setUpdated] = React.useState(0)

    useEffect(() => {    
        if (update != null && updated)
        {          
          if(update.data.scheme!=null && update.data.scheme.data.text!=null)
          {            
            setData((prev) => ({ ...prev, text: update.data.scheme.data.text }))      
            setUpdated(false)      
          }
          if(update.data.url!=null )
          {            
            setData((prev) => ({ ...prev, images: [..._data.images, update.data.url] }))      
            setUpdated(false)      
          }
        }

    }, [update]);


    if(subject != null)
        _data.subject = subject;

    const handleGenerate = (type, reason) => {     
        setUpdated(true)  
        regenerateSchemeStart({
            type: type,
            reason: reason, 
            regenerate : {
                id: schemeId,
                data: {                    
                        text: data.text ,                        
                },
            scheme: scheme,            
        }}) ;       
    }

    return (
        <div className={styles.main}>

            <div className={styles.input_block}>
                <p>Текст</p>                
                <Input
                type="textarea"
                value={_data.subject}
                onChange={(e) => setData((prev) => ({ ...prev, subject: e.target.value }))}/>


      <button hidden={isModalOpen}className={styles.button}  variant="contained" onClick={handleOpenModal}>Повторно сгенерировать текст</button>      
      <ReasonModal
      h3 = "Напишите предложения по перегенерации"
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />


               
                <Quill
                    uniq={uniq}
                    value={_data.text}
                    onChange={(value) =>
                        setData((prev) => ({ ...prev, text: value }))
                    }
                />
                {_data.speech && <AudioPlayer url={_data.speech} />}
                <InfoBlock />
                 
            </div>          
            <div className={styles.input_block}>
                
            <button hidden={isIModalOpen} className={styles.button}  variant="contained" onClick={handleOpenIModal}>Генерация изображения</button>      
      <ReasonModal
        isOpen={isIModalOpen}
        h3="Напишите текст для генерации изображения"
        onClose={handleCloseIModal}
        onSubmit={handleISubmit}
        genitem="изображения"
      />
                <p>Изображения</p>
                <Input
                    type="images"
                    value={_data.images}
                    onChange={(images) =>
                        setData((prev) => ({ ...prev, images }))
                    }
                    imagesClassName={styles.images}
                    imageClassName={styles.image}
                    iconClassName={styles.image_icon}
                    buttonsClassName={styles.buttons}
                    buttonClassName={styles.button}
                />
            </div>
            <div className={styles.input_block}>
                <p>Видео</p>
                <Input
                    type="videos"
                    value={_data.videos}
                    onChange={(videos) =>
                        setData((prev) => ({ ...prev, videos }))
                    }
                    videosClassName={styles.images}
                    videoClassName={styles.image}
                    iconClassName={styles.image_icon}
                    frameClassName={styles.youtube}
                    buttonsClassName={styles.buttons}
                    buttonClassName={styles.button}
                />
            </div>
            <div className={styles.input_block}>
                <p>Аудиозаписи</p>
                <Input
                    type="audios"
                    value={_data.audios}
                    onChange={(audios) =>
                        setData((prev) => ({ ...prev, audios }))
                    }
                    audiosClassName={styles.audios}
                    audioClassName={styles.audio}
                    iconClassName={styles.audio_icon}
                    buttonClassName={styles.button}
                    buttonsClassName={styles.buttons}
                />
            </div>
        </div>
    );
};

export { Form };
